import { render, staticRenderFns } from "./videoConfig.vue?vue&type=template&id=20a444a1&scoped=true&"
import script from "./videoConfig.vue?vue&type=script&lang=js&"
export * from "./videoConfig.vue?vue&type=script&lang=js&"
import style0 from "./videoConfig.vue?vue&type=style&index=0&id=20a444a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a444a1",
  null
  
)

export default component.exports